module.exports = __webpack_public_path__ + "static/media/match-pairs-flora.b9261875.svg";